import request from "../utils/request";

export function fetcTableData(params) {
  // is_paginated=0 page page_size

  let data = [
    {
      id: 1,
      code_region: "code_region",
      use_water: "use_water",
      water_level: "water_level",
      water_saturation: "water_saturation",
      water_mineralization: "water_mineralization",
      date: "date",
      actions: "actions"
    }
  ];
  return Promise.resolve({ data: { data, count: 1 } });
  // return request({
  //   url: "/api/orgs/geology/water-deposits/",
  //   method: "get",
  //   params
  // });
}
export function fetchChartData(params) {
  // is_paginated=0 page page_size

  return Promise.resolve([]);
  // return request({
  //   url: "/api/orgs/geology/water-deposits/",
  //   method: "get",
  //   params
  // });
}
export function fetchLocationData(params) {
  // is_paginated=0 page page_size

  return Promise.resolve({});
  // return request({
  //   url: "/api/orgs/geology/water-deposits/",
  //   method: "get",
  //   params
  // });
}
